/** Получить строку с ID для DOM элемента, являющий центральной частью приложения */
export function getMainContentContainerId() {
    return 'main-content-container';
}
